<template>
  <v-container class="mt-8">
    <v-row justify="center" align="center" dense>
      <!-- Cards de navegação para listagem -->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="$router.push({ name: 'clientes' })"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-account-group</v-icon>
            Clientes
          </v-card-title>
          <v-card-text>
            Gerencie os clientes cadastrados no sistema.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="$router.push({ name: 'licencas' })"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-certificate</v-icon>
            Licenças
          </v-card-title>
          <v-card-text>
            Gerencie as licenças dos clientes cadastrados no sistema.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="$router.push({ name: 'planos' })"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-package-variant-closed</v-icon>
            Planos
          </v-card-title>
          <v-card-text>
            Gerencie os planos cadastrados no sistema.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="$router.push({ name: 'produtos' })"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-package-variant</v-icon>
            Produtos
          </v-card-title>
          <v-card-text>
            Gerencie os produtos cadastrados no sistema.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="$router.push({ name: 'municipios' })"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-city</v-icon>
            Municípios
          </v-card-title>
          <v-card-text>
            Visualize e edite os municípios disponíveis.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="$router.push({ name: 'ufs' })"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-map</v-icon>
            UF
          </v-card-title>
          <v-card-text>
            Gerencie as Unidades Federativas (UF) do sistema.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="my-8"></v-divider>
    <h3 class="mb-4 text-center">Cadastros rápidos</h3>

    <v-row justify="center" align="center" dense>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="dialogProduto = true"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-package-variant</v-icon>
            Cadastrar Produto
          </v-card-title>
          <v-card-text> Cadastre um novo produto rapidamente. </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="dialogPlano = true"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-file-document-multiple</v-icon>
            Cadastrar Plano
          </v-card-title>
          <v-card-text> Cadastre um novo plano rapidamente. </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="custom-card"
          @click="dialogLicensa = true"
        >
          <v-card-title>
            <v-icon color="primary" size="36" class="mr-3">mdi-certificate</v-icon>
            Cadastrar Licença
          </v-card-title>
          <v-card-text> Cadastre uma nova licença rapidamente. </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <CadastroProdutoDialog v-model="dialogProduto" />
    <CadastroPlanoDialog v-model="dialogPlano" />
    <CadastroLicencaDialog v-model="dialogLicensa" />
  </v-container>
</template>

<script>
import CadastroLicencaDialog from "@/components/CadastroLicencaDialog.vue";
import CadastroPlanoDialog from "@/components/CadastroPlanoDialog.vue";
import CadastroProdutoDialog from "@/components/CadastroProdutoDialog.vue";

export default {
  components: {
    CadastroLicencaDialog,
    CadastroPlanoDialog,
    CadastroProdutoDialog,
  },
  data: () => ({
    dialogLicensa: false,
    dialogPlano: false,
    dialogProduto: false,
  }),
};
</script>

<style scoped>
.custom-card {
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  cursor: pointer;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.custom-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  transform: translateY(-4px) scale(1.025);
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  align-items: center;
  display: flex;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
  margin-top: 4px;
}
.text-center {
  text-align: center;
}
</style>
